import { UtilityLayerRenderer } from "core/Rendering/utilityLayerRenderer";
import { GizmoManager } from "core/Gizmos/gizmoManager";
import { FrameGraphUtils } from "core/FrameGraph/frameGraphUtils";
function CreateInspectorGizmoManager(scene) {
    const layer1 = scene.frameGraph ? FrameGraphUtils.CreateUtilityLayerRenderer(scene.frameGraph) : new UtilityLayerRenderer(scene);
    const layer2 = scene.frameGraph ? FrameGraphUtils.CreateUtilityLayerRenderer(scene.frameGraph) : new UtilityLayerRenderer(scene);
    const gizmoManager = new GizmoManager(scene, undefined, layer1, layer2);
    scene.reservedDataStore ??= {};
    scene.reservedDataStore.gizmoManager = gizmoManager;
    return gizmoManager;
}
export function GetInspectorGizmoManager(scene, create) {
    let gizmoManager = scene && scene.reservedDataStore && scene.reservedDataStore.gizmoManager ? scene.reservedDataStore.gizmoManager : null;
    if (!gizmoManager && create) {
        if (!scene) {
            throw new Error("Invalid scene provided to GetInspectorGizmoManager");
        }
        gizmoManager = CreateInspectorGizmoManager(scene);
    }
    return gizmoManager;
}
export function DisposeInspectorGizmoManager(scene) {
    const gizmoManager = GetInspectorGizmoManager(scene, false);
    if (!gizmoManager) {
        return;
    }
    gizmoManager.dispose();
    scene.reservedDataStore.gizmoManager = null;
}
//# sourceMappingURL=inspectorGizmoManager.js.map